import { Global, css } from '@emotion/react';
import React from 'react';

import COLORS from 'theme/colors';

const ResetCSS = (): React.ReactElement => (
  /**
   * As we merge kazaam sanitize.css to resetCSS, categorized into 4 types for future reference:
   * 1. resetCSS specific
   * 2. sanitize.css v3.3.0 specific
   * 3. resetCSS sanitize.css overlap
   * 4. resetCSS sanitize.css conflict
   * 5. DS global specific
   */

  <Global
    styles={css`
      html,
      body,
      #root {
        /* DS global specific */
        min-height: 100vh;
      }

      html,
      body {
        /* DS global specific */
        font-family: Graphik, Helvetica, sans-serif;
        font-size: 16px;
        font-weight: normal;
        line-height: 1.25;
      }

      html {
        /* resetCSS specific */
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;

        /* sanitize.css v3.3.0 specific */
        -ms-overflow-style: -ms-autohiding-scrollbar; /* Edge 12+, Internet Explorer 11- */
        overflow-y: scroll; /* All browsers without overlaying scrollbars */

        /* resetCSS sanitize.css overlap */
        -webkit-text-size-adjust: 100%;
      }

      body {
        /* resetCSS specific */
        position: relative;
        font-feature-settings: 'kern';
      }

      *,
      *::before,
      *::after {
        /* resetCSS specific */
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
      }

      main {
        /* resetCSS sanitize.css overlap */
        display: block;
      }

      hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        /* resetCSS sanitize.css overlap */
        overflow: visible;
      }

      pre,
      code,
      kbd,
      samp {
        /* resetCSS sanitize.css conflict & choosing resetCSS */
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        /* resetCSS specific */
        font-size: 1em;
      }

      pre {
        /* sanitize.css v3.3.0 specific */
        overflow: auto; /* Internet Explorer 11- */
      }

      a {
        /* resetCSS specific */
        background-color: transparent;
        /* resetCSS sanitize.css conflict & choosing kazaam */
        text-decoration: none;
      }

      abbr[title] {
        /* resetCSS specific */
        border-bottom: none;
        /* resetCSS sanitize.css overlap */
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }

      b,
      strong {
        /* resetCSS sanitize.css conflict & choosing kazaam */
        font-weight: bolder; /* Edge 12+, Safari 6.2+, and Chrome 18+ */
      }

      small {
        /* resetCSS sanitize.css conflict & choosing resetCSS */
        font-size: 75%;
      }

      audio:not([controls]) {
        /* sanitize.css v3.3.0 specific */
        display: none; /* Chrome 44-, iOS 8+, Safari 9+ */
      }

      button,
      input {
        /* resetCSS specific */
        overflow: visible;
      }

      button,
      select {
        /* resetCSS sanitize.css overlap */
        text-transform: none;
      }

      button::-moz-focus-inner,
      [type='button']::-moz-focus-inner,
      [type='reset']::-moz-focus-inner,
      [type='submit']::-moz-focus-inner {
        /* resetCSS specific */
        border-style: none;
        /* sanitize.css v3.3.0 specific */
        border: 0; /* Firefox 4+ */
        /* resetCSS sanitize.css overlap */
        padding: 0;
      }

      legend {
        /* resetCSS specific */
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }

      [type='checkbox'],
      [type='radio'] {
        /* resetCSS specific */
        box-sizing: border-box;
        padding: 0;
      }

      [type='number']::-webkit-inner-spin-button,
      [type='number']::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }

      input[type='number'] {
        /* resetCSS specific */
        -moz-appearance: textfield;
      }

      [type='search'] {
        /* resetCSS specific */
        outline-offset: -2px;
        /* resetCSS sanitize.css overlap */
        -webkit-appearance: textfield;
      }

      input[type='search']::-webkit-search-cancel-button,
      input[type='search']::-webkit-search-decoration {
        /* resetCSS sanitize.css overlap */
        -webkit-appearance: none !important;
      }

      ::-webkit-file-upload-button {
        /* resetCSS specific */
        -webkit-appearance: button;
        font: inherit;
      }

      details {
        /* resetCSS sanitize.css overlap */
        display: block;
      }

      summary {
        /* resetCSS sanitize.css conflict & choosing resetCSS */
        display: list-item;
      }

      template {
        /* resetCSS sanitize.css overlap */
        display: none;
      }

      [hidden] {
        /* resetCSS sanitize.css overlap */
        display: none !important;
      }

      * {
        /* resetCSS sanitize.css overlap */
        margin: 0;
        /* sanitize.css v3.3.0 specific */
        font-size: inherit;
        line-height: inherit;
        padding: 0;
        background-repeat: no-repeat;
      }

      button {
        /* resetCSS specific */
        background: transparent;
        padding: 0;
        /* sanitize.css v3.3.0 specific */
        -webkit-appearance: button; /* iOS 8+ */
        overflow: visible; /* Internet Explorer 11- */
      }

      fieldset {
        /* resetCSS specific */
        margin: 0;
        padding: 0;
      }

      progress {
        /* resetCSS specific */
        vertical-align: baseline;
        /* sanitize.css v3.3.0 specific */
        display: inline-block; /* Internet Explorer 11-, Windows Phone 8.1+ */
      }

      textarea {
        /* resetCSS specific */
        overflow: auto;
        /* resetCSS sanitize.css overlap */
        resize: vertical;
      }

      button,
      [role='button'] {
        /* resetCSS specific */
        cursor: pointer;
      }

      table {
        /* sanitize.css v3.3.0 specific */
        border-spacing: 0;
        /* resetCSS sanitize.css overlap */
        border-collapse: collapse;
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        /* resetCSS specific */
        font-size: inherit;
        font-weight: inherit;
      }

      button,
      input,
      optgroup,
      select,
      textarea {
        /* resetCSS specific */
        padding: 0;
        line-height: inherit;
        color: inherit;
        /* sanitize.css v3.3.0 specific */
        font-family: inherit;
        font-style: inherit;
        font-weight: inherit;
      }

      img,
      svg,
      video,
      canvas,
      audio,
      iframe,
      embed,
      object {
        /* sanitize.css v3.3.0 specific */
        vertical-align: middle;
      }

      img,
      video {
        /* resetCSS specific */
        height: auto;
      }

      [data-js-focus-visible] :focus:not([data-focus-visible-added]) {
        /* resetCSS specific */
        outline: none;
        box-shadow: none;
      }

      select::-ms-expand {
        /* resetCSS sanitize.css overlap */
        display: none;
      }

      input::-moz-focus-inner {
        /* sanitize.css v3.3.0 specific */
        border: 0; /* Firefox 4+ */
        padding: 0; /* Firefox 4+ */
      }

      input {
        /* sanitize.css v3.3.0 specific */
        -webkit-border-radius: 0; /* iOS 8+ */
      }

      input[type='button'],
      input[type='reset'],
      input[type='submit'] {
        /* sanitize.css v3.3.0 specific */
        -webkit-appearance: button; /* iOS 8+ */
      }

      svg:not(:root) {
        /* sanitize.css v3.3.0 specific */
        overflow: hidden; /* Internet Explorer 11- */
      }

      *,
      :before,
      :after {
        /* sanitize.css v3.3.0 specific */
        box-sizing: inherit;
      }

      :before,
      :after {
        /* sanitize.css v3.3.0 specific */
        text-decoration: inherit;
        vertical-align: inherit;
      }

      *,
      :before,
      :after {
        /* sanitize.css v3.3.0 specific */
        border-style: solid;
        border-width: 0;
      }

      a,
      area,
      button,
      input,
      label,
      select,
      textarea,
      [tabindex] {
        /* sanitize.css v3.3.0 specific */
        -ms-touch-action: manipulation;
        touch-action: manipulation;
      }

      select {
        /* sanitize.css v3.3.0 specific */
        -moz-appearance: none; /* Firefox 40+ */
        -webkit-appearance: none; /* Chrome 45+ */
      }

      select::-ms-value {
        /* sanitize.css v3.3.0 specific */
        color: currentColor; /* Edge 12+, Internet Explorer 11- */
      }

      svg {
        /* sanitize.css v3.3.0 specific */
        fill: currentColor;
      }

      [aria-busy='true'] {
        /* sanitize.css v3.3.0 specific */
        cursor: progress;
      }

      [aria-controls] {
        /* sanitize.css v3.3.0 specific */
        cursor: pointer;
      }

      [aria-disabled] {
        /* sanitize.css v3.3.0 specific */
        cursor: default;
      }

      [hidden][aria-hidden='false'] {
        /* sanitize.css v3.3.0 specific */
        clip: rect(0 0 0 0);
        display: inherit;
        position: absolute;
      }

      [hidden][aria-hidden='false']:focus {
        /* sanitize.css v3.3.0 specific */
        clip: auto;
      }

      :root {
        /* sanitize.css v3.3.0 specific */
        background-color: ${COLORS.silver.lightest};
        box-sizing: border-box;
        color: ${COLORS.black.base};
        font: 100%/1.5 sans-serif;
      }

      button,
      input,
      select,
      textarea {
        /* sanitize.css v3.3.0 specific */
        background-color: transparent;
        color: inherit;
      }

      button,
      [type='button'],
      [type='date'],
      [type='datetime'],
      [type='datetime-local'],
      [type='email'],
      [type='month'],
      [type='number'],
      [type='password'],
      [type='reset'],
      [type='search'],
      [type='submit'],
      [type='tel'],
      [type='text'],
      [type='time'],
      [type='url'],
      [type='week'],
      select,
      textarea {
        /* sanitize.css v3.3.0 specific */
        min-height: 1.5em;
      }

      nav ol,
      nav ul {
        /* sanitize.css v3.3.0 specific */
        list-style: none;
      }

      ::-moz-selection {
        /* sanitize.css v3.3.0 specific */
        background-color: ${COLORS.blue.lighter};
        color: ${COLORS.black.base};
      }

      ::selection {
        /* sanitize.css v3.3.0 specific */
        background-color: ${COLORS.blue.lighter};
        color: ${COLORS.black.base};
      }
    `}
  />
);

export default ResetCSS;
